export default __webpack_public_path__ + "static/media/tanzania.64df28f4.jpg";